import { PageHeader, Tabs } from "@/components";
import { useSearchParamsInPlace } from "@/lib/hooks";
import { CoverageTab } from "./CoverageTab";
import styles from "./KnowledgePage.module.css";
import { UsageTab } from "./UsageTab";
import { VocabularyTab } from "./VocabularyTab";

const TABS = [
  { value: "vocabulary", label: "Odor vocabulary" },
  { value: "coverage", label: "Organ coverage" },
  { value: "usage", label: "Usage ranges" },
] as const;
type TabValue = (typeof TABS)[number]["value"];

function isTab(value: string | null): value is TabValue {
  return TABS.some((tab) => tab.value === value);
}

/** The reference knowledge behind the materials: odor vocabulary, coverage of reference lists, usage ranges. */
export function KnowledgePage() {
  const [searchParams, setSearchParams] = useSearchParamsInPlace();
  const tabParam = searchParams.get("tab");
  const tab: TabValue = isTab(tabParam) ? tabParam : "vocabulary";

  function selectTab(value: TabValue) {
    setSearchParams(value === "vocabulary" ? {} : { tab: value }, { replace: true });
  }

  return (
    <div className={styles.page}>
      <PageHeader
        title="Knowledge"
        description="ScenTree’s odor vocabulary, how much of a reference list you own, and the doses materials are used at."
      />
      <Tabs.Root value={tab} onValueChange={selectTab}>
        <Tabs.List label="Knowledge sections">
          {TABS.map((item) => (
            <Tabs.Tab key={item.value} value={item.value}>
              {item.label}
            </Tabs.Tab>
          ))}
        </Tabs.List>
        <Tabs.Panel value="vocabulary">
          <VocabularyTab />
        </Tabs.Panel>
        <Tabs.Panel value="coverage">
          <CoverageTab />
        </Tabs.Panel>
        <Tabs.Panel value="usage">
          <UsageTab />
        </Tabs.Panel>
      </Tabs.Root>
    </div>
  );
}
